module.exports = __webpack_public_path__ + "img/hzfp20.12d2c8fd.png";